module.exports = __webpack_public_path__ + "img/img5.11733d03.png";